document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".rxn-accordion-header").forEach(function(header){

    header.addEventListener("click", function(){

      const item = this.parentElement;
      const content = item.querySelector(".rxn-accordion-content");
      const isOpen = item.classList.contains("active");

      // Close all
      document.querySelectorAll(".rxn-accordion-item").forEach(function(acc){

        acc.classList.remove("active");

        acc.querySelector(".rxn-accordion-content").style.maxHeight = null;

      });

      // Open clicked
      if(!isOpen){

        item.classList.add("active");

        content.style.maxHeight = content.scrollHeight + "px";


      }

    });

  });

  // Default open item (agar active class lagi ho)
  const active = document.querySelector(".rxn-accordion-item.active");

  if(active){

    const content = active.querySelector(".rxn-accordion-content");

    content.style.maxHeight = content.scrollHeight + "px";
        

  }

});